/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Layers_OfficeInputs */

const cs_integrations_layers_office = /** @type {(inputs: Integrations_Layers_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeden importní účet Sreality RK pro celou kancelář. Každý inzerát jde přes něj. Katastr a CEE jsou taky sdílené.`)
};

const en_integrations_layers_office = /** @type {(inputs: Integrations_Layers_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One Sreality RK import for the whole office. Every listing exports through it. Cadastre and CEE lookups are shared too.`)
};

/**
* | output |
* | --- |
* | "One Sreality RK import for the whole office. Every listing exports through it. Cadastre and CEE lookups are shared too." |
*
* @param {Integrations_Layers_OfficeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_layers_office = /** @type {((inputs?: Integrations_Layers_OfficeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Layers_OfficeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_layers_office(inputs)
	return cs_integrations_layers_office(inputs)
});